/*** IMPORTS FROM imports-loader ***/
var define = false;

export default {
	message: {
		hello: 'hello world'
	},
	home: {
		slogan: "Asthma tracking with your doctor",
		//intro: "Pulmoment is a new healthcare software for asthma patients and their doctors. Our system improves the mandatory consultations by enabling users to answer the routine questions before the personal meeting. With this, we save time and provide continuous global overview about the health condition changes of the patient.",
		intro: "Pulmoment was a mobile software for asthma patients and their doctors. The project was developed between 2016 to 2018 by a group of students at Eötvös Loránd University in collaboration with Dr. András Szánthó. Due to the lack of funding, the support of the software has concluded in 2023. We hope our work will be used as a reference to build better healthcare solutions in the future. We're thankful for the support of our users and the medical community.",
		supportTitle: "Supported by",
		introtitle: "Condition tracking in a simple way",
		featurefirst: "Direct contact with your doctor",
		featurefirstdesc: "Through the application you can send messages to you doctor, who gets notification about critical symptoms and sees your condition changes in real time",
		featuresecond: "Questions, when it's needed",
		featureseconddesc: "Every patient is unique, therefore the system will check the measured data, so you have to fill the health survey only when it's needed",
		featurethird: "Health predictions",
		featurethirddesc: "Based on the recurring questions, we create unique reports from your data and notify you about the possible upcoming symptoms and the critical allergy seasons.",
		featurefourth: "Manage visit appointments",
		featurefourthdesc: "The application will send notifications about visits in the near future and changes in the appointment or about substitution",
		doctorslogan: "Overview about your patients, with a single click",
		doctorregistrate: "Registrate for free on the link below to get a better picture about you pateint's condition.",
		doctorregistrateinfo: "You can only have to leave your e-mail or phone number, and our team will contact you after finished setting up your profile.",
		specialThanks: "Special thanks for the help:",
		titleDaniel: "Project leader, software developer",
		titleLevente: "Mobile application developer",
		titleAndras: "Medical consultant",
		titleJulia: "Marketing and sales",
		titleMano: "PR and technological support",
		titleFanni: "Web application developer",
		titleDamiano: "Business developer",
		videotitle: "See it in action",
		fbtwitter: "Follow us on <a href=\"https://www.facebook.com/pulmoment/\" target=\"_blank\">Facebook</a> and <a href=\"https://twitter.com/pulmoment\" target=\"_blank\">Twitter</a> for news and updates."
	},

	milestones:{
		"title": "Milestones",
		"intro":{
			"date": "Spring of 2016",
			"title": "We started",
			"desc": "The beginning of the design phase based on the problems with the medical consultations of asthma patients. During this time, our team worked under the name of Symbimed, which was changed to Pulmoment by the summer of 2016. The new name is easier to understand and reflects our goals even better."
		},
		"elte":{
			"date": "2016.05.11.",
			"title": "ELTE Innovative Student Idea Award",
			"desc": "Our idea was awarded first place at the ELTE Innovative Student Idea Award 2016 by the largest Hungarian university. Our team assembled at the Faculty of Informatics, and we are proud to work with students of ELTE. We will continue to cooperate with the university, through R&D activities."
		},
		"district":{
			"date": "2016.05.17.",
			"title": "Students' Startup Competition of Újbuda",
			"desc": "The project was awarded by the Council of Újbuda. We believe that Újbuda is the most innovative district of Budapest, due to a large number of IT companies and presence of universities. This is the reason why we positioned our product development here."
		},
		"pediatricBeta":{
			"date": "2016.11.04.",
			"title": "52. Hungarian Pediatric Pulmonology Conference - First public beta version",
			"desc": "We introduced the first public beta version during the event, with the interface for both doctors and patients. This was the first time when we presented our project for a pulmonologist audience and their feedback confirmed the need for our service."
		},
		"pilotRelease":{
			"date": "2017.04.27.",
			"title": "First public release",
			"desc": "We released the first public version of Pulmoment, in a pilot phase. First, we test our solutions with a group of patients in Hungary, while we still working on new features."
		},
		"gitr":{
			"date": "2017.05.12.",
			"title": "Get in the Ring - Chendgu",
			"desc": "Enterprise Hungary and the Hungarian National Trading House selected Pulmoment to be one of four competing Hungarian startups at the Get in the Ring competition in China. In the end, a Chinese startup won the grand prize, however, after the event, we had the chance to learn about the local culture and the state of the local healthcare situation. The number of chronic pulmonary patients in China is extraordinary high, so our service could be a really useful solution for both the governmental and the private care. A group of local doctors agreed to support our cause."
		},
		"beSmart":{
			"date": "2017.06.22.",
			"title": "Hungarian e-Health Day - Düsseldorf",
			"desc": "Budapest Enterprise Agency provided us an opportunity to present our product in Germany during the Hungarian e-Health Day event. By the local competition in Düsseldorf, Pulmoment won the second prize. Besides this, we had the chance to learn about the local healthcare innovations and the services for international startups."
		},
		"ministry":{
			"date": "2017.07.14.",
			"title": "Startup of the Month Award",
			"desc": "The Hungarian Ministry for National Economy awarded Pulmoment as the Startup of the Month in June."
		},
		"now":{
			"date": "Now",
			"title": "Moving forward",
			"desc": "We are continuously looking for pulmonologists, research institutions and healthcare organizations for partnership. If you agree with our goals, please contact us for further details."
		}
	},

	admin: {
		edit_news: "Edit news",
		editnews_note: "Below you can write short news for your patients about general informations or consulting hours.",
		title: "Title",
		content: "Content",
		image: "Image",
		general: "General",
		change_appointment: "Change of appointment",
		substitution: "Substitution",
		release: "Release",
		save: "Save",
		facebook_link: "Facebook link",
		website: "Website",
		healthcareId: "Healthcare ID",
		discipline: "Discipline",
		add_new: "Add new",
		needsignin: "Please sign in to view this page",
		current: "Current",
		consultinghours: "Soon you can set your consulting hours in our system.",
		nextoverall: "Next report",
		novisit: "No visits in the future",
		totalizedsymptoms: "Summarized number of symptoms in the past month",
		allpatients: "All patients",
		filledinspector: "Filled monthly control survey",
		noinspector: "No filled control survey yet",
		newpatients: "New registered patients",
		rescueMedUsage: "Rescue medication usage",
		summary: "Summary",
		numberofsymptoms: "Number of symptoms",
		lastFourWeek: "last four week",
		symptom: "Symptom",
		data: "Data",
		patientspage: "Patient's page",
		mothersname: "Mother's name:",
		socialsecuritynumber: "Social security number:",
		medicines: "Medicines:",
		printsummary: "Print medical summary",
		findinspector: "Send control survey request",
		useofmedicines: "Medication usage",
		rescueMedSymptom: "Symptoms and rescue medication usage",
		factor: "Factor",
		value: "Value",
		tendency: "Tendency",
		patients: "Patients",
		doctors: "Doctors",
		descinfo: "In the mobile application patients can find your data. Please make sure you give data that can be seen by everyone",
		doctorspage: "Doctor's page",
		sendfeedback: "Send feedback",
		feedbackinfo: "Send your opinion about our application. Here you can report a problem about the software or the medical data",
		phonenumber: "Phone number",
		message: "Message",
		monthlyReport: "Monthly report",
		dailyReport: "Daily report"
	},

	for_patients: "For patients",
	doctors: "For doctors",
	see_more: "See more",
	read_more: "Read more",
	contact_us: "Contact Us",
	contact_us_directly: "Contact us directly:",
	app_links: "Pulmoment is available for Android and iOS devices:",
	thank_you: "In 2023 the development of Pulmoment has ended and it's not available anymore on the App Store or Google Play.",

	report_feedback: "Report problem, send feedback, or any other information",
	contact: "Contact",
	sign_in: "Sign In",
	sign_out: "Sign Out",
	email: "E-mail",
	password: "Password",
	cancel: "Cancel",
	home_page: "Home",
	patients: "Patients",
	profile: "Profile",
	news: "News",
	report_problem: "Bug report",
	signin_note: "This page is for doctors only. Patients can download our application from Google Play or the App Store. If you don't have an account, you can register one for free in the 'Registration' link below.",
	registration: "Registration",
	name: "Name",
	attributes: "Attributes",
	introduction: "Introduction",
	contact_name: "Contact name",
	contact_data: "Contact data",
	peakflowmeter: "Peak flow meter",
	peakflowmeterinfo: "The peak flow meter can be used at home. It shows the airways stricture increasing before the symptoms appear. It presage the asthma episode if the measured values are lower than the usual values. If the daily wobbling of the peak flow passes 20% it indicates asthma, more than 20-30% wobbling indicate serious inflamation and obstruction. Please ask your doctor what to do in this situation.",
	peakflowmeterlink: "Details:",









	
}



// WEBPACK FOOTER //
// ./src/strings/en.js